const KlaviyoPopupNow = {
  template: /*html*/ `
  <Teleport to="body" > 

  <div class="relative z-[1000]"
  :class = "{'loaded_animation': startAnimation}" 
  v-if="isModalOpen"
  aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-0  text-center sm:items-center sm:p-0">
      <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" @click="closeQuickView"></div>

        <!--  close svg --> 

      
      <div 
        
      class="fixed bottom-0 md:relative transform  text-left  transition-all sm:my-8 sm:w-full sm:max-w-[95%] 2xl:max-w-[600px] w-full  sm:align-middle sm:rounded-lg sm:shadow-xl" 
      :class = "{'opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95': !AnimatedModalToShow, 'opacity-100 translate-y-0 sm:scale-100': AnimatedModalToShow}"
       
      >
      
     
         <div class="fixed top-0 right-0 pt-4 pr-4 z-20" >
          <button type="button" class="text-[#1E4036] hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-white bg-white"
          @click="closeQuickView"
          >
            <span class="sr-only">Close</span>
            <!-- Heroicon name: outline/x -->
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button> 
        </div> 
        <div class="pl-wrapper pl-wrapper-product-section bg-white p-2 overflow-x-hidden overflow-y-scroll px-[30px] py-[20px]" v-if="formReady && submittingSuccess">
            <div class="py-[30px] relative text-center min-h-[350px]" >
            <h1 class="text-[30px] text-[#56A511">
            Thank you for signing up!
            </h1> 
            <p v-if="prolonExperience != 'firstTime'" class="py-[20px]">
            Check your email for a confirmation message.
            </p>  


        <div v-if="prolonExperience === 'firstTime'" >
         <p class="py-[20px]">
           Thanks for starting your longevity journey with Prolon! For your first round of Prolon, enjoy a complimentary 15 Minute 1 on 1 session with a longevity coach  discuss the ways to optimize your longevity journey.
            </p>  

<div id="calendly-inline-widget" class="mt-[20px]" data-url="
https://calendly.com/longevitycoach-l-nutra/30min?hide_event_type_details=1&hide_gdpr_banner=1"
style="min-width:320px;height:700px;">
</div>
</div>



          
        </div>
        </div>
      <div class="pl-wrapper pl-wrapper-product-section bg-white p-2 overflow-x-hidden overflow-y-scroll px-[30px] py-[20px]" v-if="formReady && !submittingSuccess">
 
      <div class="py-[30px] relative text-center">
      <h1 class="text-[27px] text-[#56A511] max-w-[400px] mx-auto"
      v-html="popup_title" 
      >
      </h1>  

      <p class="py-[20px] text-[#56A511text-[#1E4036]"
      v-html="popup_description"
      >
      </p>

<form class="max-w-[315px] mx-auto" data-form-type="other"
  @submit.prevent="sendToKlaviyo()"
>
  <div class="mb-6">
    <label for="FirstName" class="block font-medium mb-2 text-[#1E4036] text-sm text-left">First Name</label>
    <input type="text" id="FirstName" 
    v-model="first_name"
    class="bg-gray-50 block border border-gray-300 p-2.5 text-[#1E4036] text-sm w-full"  required
    >
  </div>
  <div class="mb-6">
    <label for="LastName" class="block font-medium mb-2 text-[#1E4036] text-sm text-left">Last Name</label>  
    <input type="text" id="LastName"
    v-model="last_name"
    class="bg-gray-50 block border border-gray-300 p-2.5 text-[#1E4036] text-sm w-full"  required
    >
  </div> 
  <div class="mb-6">
    <label for="Email" class="block font-medium mb-2 text-[#1E4036] text-sm text-left">Email</label>
    <input type="email"
    v-model="email"
    id="Email" class="bg-gray-50 block border border-gray-300 p-2.5 text-[#1E4036] text-sm w-full"  required
    >
  </div>

  
  <div class="mb-6 hidden">
    <label class="block font-medium mb-2 text-[#1E4036] text-sm text-left">Have you done Prolon before?</label>
    <div class="!flex flex-col gap-2"> 
      <div class="flex ">
        <input type="radio" name="prolonExperience" id="firstTime" value="firstTime" v-model="prolonExperience" class=" cursor-pointer" />
        <label for="firstTime" class="!mb-0">
          <p class=" !normal-case text-[16px]  font-normal tracking-[0] ">This is my first time doing Prolon</p>
        </label>
      </div>
      <div class="flex "> 
        <input type="radio" name="prolonExperience" id="previouslyDone" value="previouslyDone" v-model="prolonExperience" class=" cursor-pointer" />
        <label for="previouslyDone" class="!mb-0">
          <p class=" !normal-case text-[16px]  font-normal tracking-[0] ">I have done Prolon previously</p>
        </label>
      </div>
    </div>
  </div>

  <button type="submit" class="text-white btn rounded-full !bg-[#56A511] w-full mt-4">
    {{isSubmitting ? 'Submitting...' : 'Submit'}}
  </button>
</form>

</div>

  
      </div> 
 

      <!-- Loading Skeleton -->
      <div class="flex-1 bg-white p-2" v-if="!formReady">
        <div class="relative">
          <div class="mx-auto pt-0 lg:max-w-[800px] md:px-[0px]">
            <div class="animate-pulse py-[30px] px-4">
              
              <!-- Title Skeleton -->
              <div class="mb-6">
                <div class="bg-gray-200 h-[32px] w-[300px] mx-auto rounded"></div>
              </div>

              <!-- Description Skeleton -->
              <div class="mb-8 max-w-[400px] mx-auto">
                <div class="bg-gray-200 h-3 mb-3 rounded-full"></div>
                <div class="bg-gray-200 h-3 mb-3 rounded-full w-[90%] mx-auto"></div>
                <div class="bg-gray-200 h-3 w-[70%] mx-auto rounded-full"></div>
              </div>

              <!-- Form Fields Skeleton -->
              <div class="max-w-[315px] mx-auto space-y-4">
                <!-- First Name Field -->
                <div class="bg-gray-200 h-[48px] w-full rounded"></div>
                
                <!-- Last Name Field -->
                <div class="bg-gray-200 h-[48px] w-full rounded"></div>
                
                <!-- Email Field -->
                <div class="bg-gray-200 h-[48px] w-full rounded"></div>
                
                <!-- Submit Button -->
                <div class="bg-gray-300 h-[50px] w-full rounded mt-6"></div>
              </div>

              <span class="sr-only">Loading form...</span>
            </div>
          </div>
        </div>
      </div>
       
      </div>
    </div>
  </div>
</div>

  </Teleport>

  `,
  props: [
    "handle",
    "button_name",
    "settings",
    "doctor_name",
    "data_range",
    "list_id",
    "popup_title",
    "popup_description",
  ],
  data() {
    return {
      isModalOpen: false,
      AnimatedModalToShow: false,
      startAnimation: false,
      formReady: false,
      isSubmitting: false,
      first_name: "",
      last_name: "",
      email: "",
      submittingSuccess: false,
    };
  },
  computed: {},

  methods: {
    closeQuickView: function () {
      this.AnimatedModalToShow = false;
      $("body").removeClass("overflow-hidden");
      setTimeout(() => {
        this.isModalOpen = false;
      }, 300);
    },
    sendToKlaviyo() {
      let { email, first_name, last_name } = this;
      this.isSubmitting = true;

      var myHeaders = new Headers();
      myHeaders.append("accept", "application/json");
      myHeaders.append("content-type", "application/json");
      let profile = {
        email: email,
        $email: email,
        $first_name: first_name,
        $last_name: last_name,
        $source: this.doctor_name + " - Form",
        $consent: "klaviyo",
        $consent_method: "Klaviyo Form",
        $consent_version: "v1.0",
        data_range: this.data_range,
        doctor_name: this.doctor_name,
      };

      var raw = JSON.stringify({
        profiles: [profile],
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
        cors: "no-cors",
      };
      let listId = this.list_id;
      fetch(
        "https://prolon-pro.herokuapp.com/stores/submit-to-klaviyo?list_id=" +
          listId,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          this.isSubmitting = false;
          this.submittingSuccess = true;
          setTimeout(() => {
            Calendly.initInlineWidget({
              url: "https://calendly.com/longevitycoach-l-nutra/30min?hide_event_type_details=1&hide_gdpr_banner=1",
              parentElement: document.getElementById("calendly-inline-widget"),
            });
          }, 100);

          console.log(result);
        })
        .catch((error) => {
          this.isSubmitting = false;
          this.submittingSuccess = false;
          alert("Something went wrong. Please try again later.");
          console.log("error", error);
        });
    },
    openQuickView: function () {
      this.isModalOpen = true;
      $("body").addClass("overflow-hidden");
      setTimeout(() => {
        this.AnimatedModalToShow = true;
      }, 100);
      setTimeout(() => {
        this.formReady = true;
      }, 500);
      // this.getProductByHandle(this.handle);
    },
  },
  watch: {},
  mounted() {
    // Each instance registers its own trigger on the parent element
    this.$nextTick(() => {
      const parentElement = this.$el.parentElement?.closest('.klaviyo-form-wrapper') || this.$el.closest('.klaviyo-form-wrapper');
      if (parentElement) {
        parentElement._openKlaviyoPopup = () => {
          this.openQuickView();
        };
      }
    });
  },
};

function removeProtocol(path) {
  return path.replace(/http(s)?:/, "");
}
function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === "master") {
    return removeProtocol(src);
  }

  const match = src.match(
    /\.(webp|jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
  );

  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];

    return removeProtocol(`${prefix[0]}_${size}${suffix}`);
  } else {
    return null;
  }
}
function getSizedImageSrcSet(src) {
  const imageSizes = [100, 480, 960, 1440, 1920, 2560, 3840];

  return imageSizes
    .map((size) => `${getSizedImageUrl(src, size + "x")} ${size}w`)
    .join(", ");
}

if (document.querySelector(".klaviyo-form-wrapper")) {
  const productImage = Vue.ref(null);
  // Vue.use(VueCalendly);

  let klaviyoSections = document.querySelectorAll(".klaviyo-form-wrapper");

  klaviyoSections.forEach((klaviyoSection) => {
    const productForm = Vue.createApp({
      delimiters: ["${", "}"],
      data() {
        return {};
      },       
      methods: {},
      computed: {},
      watch: {},
      components: {
        "klaviyo-popup-now": KlaviyoPopupNow,
      },
      mounted() {},
      created() {},
    }).mount(klaviyoSection);
  });
}

jQuery(document).ready(function ($) {
  // Handle klaviyo popup trigger
  $(document).on("click", ".klaviyo-form-wrapper.open-quick-view, .klaviyo-form-wrapper .open-quick-view", function (e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('Klaviyo trigger clicked');
    
    // Find the closest klaviyo-form-wrapper and use its instance-specific trigger
    const wrapper = $(this).closest('.klaviyo-form-wrapper')[0];
    if (wrapper && wrapper._openKlaviyoPopup) {
      wrapper._openKlaviyoPopup();
    } else {
      console.error('Instance-specific trigger not available');
    }
  });
  
  $(".product-image-view-button").click(function (e) {
    $(this).closest(".single-product-card").find(".open-quick-view")[0].click();
  });
});
